import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import { useSelector } from 'react-redux';

export default function LoadBar() {
  const loading = useSelector(state => state.loading)
  if(loading.load === 0){
    return null
  }
  return <LinearProgress variant="query"/>
}